import { SpotlightDocumentSchema } from "@redotech/redo-spotlight-common/spotlight-document-schema";
import { SpotlightFormSchema } from "@redotech/redo-spotlight-common/spotlight-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateSpotlight = {
  name: "updateSpotlight" as const,
  input: z.object({
    spotlightId: zExt.objectId(),
    form: SpotlightFormSchema,
    enabled: z.boolean().optional(),
  }),
  output: z.object({ spotlight: SpotlightDocumentSchema.nullable() }),
};
